import stencilReduxGlobalScript from '/net/rngvm01001/fs0/jenkins-slave/workspace/en.components-npm_release_12.1.0/node_modules/@stencil/redux/dist/collection/global/store.js';
import bcpcomponentsGlobalScript from '/net/rngvm01001/fs0/jenkins-slave/workspace/en.components-npm_release_12.1.0/src/globals/global.ts';
export const globalScripts = () => {
  return Promise.all([
    bcpcomponentsGlobalScript(),
    stencilReduxGlobalScript(),
  ]);
};
